import {createCopyPasteContextAndProvider} from './use-copy-paste/create-copy-paste-context-and-provider'

export const {CopyPasteProvider, useCopyPaste} = createCopyPasteContextAndProvider()
